/**
 * 路由配置文件
 */
import pivCar from '../deps/routes/pivCar'
import menus from '../deps/routes/index'

export default function() {
  return [...pivCar, ...menus]
    .map(i => {
      return {
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: `/${i.realUrl || i.url}`,
          name: i.realUrl || i.url,
          meta: [
            {
              title: i.metaName || '非车业务'
            },
            {
              title: i.name,
              path: `${i.realUrl || i.url}`
            }
          ], // 面包屑导航
          component: () => import(`../pages/${i.parent}/${i.url}`)
        }
      }
    })
    .concat([
      {
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/',
          name: '/',
          meta: [
            {
              title: '首页',
              path: '/'
            }
          ], // 面包屑导航
          component: () => import('../pages/nil/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/home',
          name: 'home',
          meta: [
            {
              title: '首页',
              path: 'home'
            }
          ], // 面包屑导航
          component: () => import('../pages/home/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/login',
          name: 'login',
          meta: [
            {
              title: '登录',
              path: 'login'
            }
          ], // 面包屑导航
          component: () => import('../pages/login/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/user',
          name: 'user',
          meta: [
            {
              title: '员工管理',
              path: 'user'
            }
          ], // 面包屑导航
          component: () => import('../pages/user/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/role',
          name: 'role',
          meta: [
            {
              title: '职务列表',
              path: 'role'
            }
          ], // 面包屑导航
          component: () => import('../pages/role/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/menu',
          name: 'menu',
          meta: [
            {
              title: '菜单列表',
              path: 'menu'
            }
          ], // 面包屑导航
          component: () => import('../pages/menu/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/car-lists',
          name: 'car-lists',
          meta: [
            {
              title: '车型数据',
              path: 'car-lists'
            }
          ], // 面包屑导航
          component: () => import('../pages/car-lists/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/insurance-lists',
          name: 'insurance-lists',
          meta: [
            {
              title: '4S店管理',
              path: 'insurance-lists'
            }
          ], // 面包屑导航
          component: () => import('../pages/insurance-lists/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/insurance-codes',
          name: 'insurance-codes',
          meta: [
            {
              title: '4S店账号管理',
              path: 'insurance-codes'
            }
          ], // 面包屑导航
          component: () => import('../pages/insurance-codes/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/banner',
          name: 'banner',
          meta: [
            {
              title: 'Banner管理',
              path: 'banner'
            }
          ], // 面包屑导航
          component: () => import('../pages/banner/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/gift-lists',
          name: 'gift-lists',
          meta: [
            {
              title: '奖励配置',
              path: 'gift-lists'
            }
          ], // 面包屑导航
          component: () => import('../pages/gift-lists/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/vip-lists',
          name: 'vip-lists',
          meta: [
            {
              title: '会员管理',
              path: 'vip-lists'
            }
          ], // 面包屑导航
          component: () => import('../pages/vip-lists/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/order-lists',
          name: 'order-lists',
          meta: [
            {
              title: '订单处理',
              path: 'order-lists'
            }
          ], // 面包屑导航
          component: () => import('../pages/order-lists/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/sys-cooperative-lists',
          name: 'sys-cooperative-lists',
          meta: [
            {
              title: '4S店会员',
              path: 'sys-cooperative-lists'
            }
          ], // 面包屑导航
          component: () => import('../pages/sys-cooperative-lists/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/sys-cooperative-order',
          name: 'sys-cooperative-order',
          meta: [
            {
              title: '券码对账',
              path: 'sys-cooperative-order'
            }
          ], // 面包屑导航
          component: () => import('../pages/sys-cooperative-order/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/cooperative-lists',
          name: 'cooperative-lists',
          meta: [
            {
              title: '4S店会员',
              path: 'cooperative-lists'
            }
          ], // 面包屑导航
          component: () => import('../pages/cooperative-lists/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/cooperative-order',
          name: 'cooperative-order',
          meta: [
            {
              title: '券码对账',
              path: 'cooperative-order'
            }
          ], // 面包屑导航
          component: () => import('../pages/cooperative-order/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/discount',
          name: 'discount',
          meta: [
            {
              title: '折扣管理',
              path: 'discount'
            }
          ], // 面包屑导航
          component: () => import('../pages/discount/index')
        }
      },
      {
        isCache: false,
        permission: 'all', // 权限控制，无具备权限将会被筛选掉
        route: {
          path: '/car-package',
          name: 'car-package',
          meta: [
            {
              title: '车型数据',
              path: 'car-lists'
            },
            {
              title: '品牌套餐',
              path: 'car-package'
            }
          ], // 面包屑导航
          component: () => import('../pages/car-lists/package')
        }
      }
    ])
}



// WEBPACK FOOTER //
// ./src/app/sitmap.js